// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 1%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Navbar Styling */
.navbar {
  position: fixed; 
  top: 10%; 
  left: 50%; 
  width: 90%; 
  max-width: 1200px; 
  background-color: rgba(0, 0, 0, 0.25);
  box-shadow: none;
  padding: 1rem 2rem;
  z-index: 1000; 
  border-radius: 10px; 
  transition: background-color 0.3s ease;
  transform: translateX(-50%); 
  display: flex;
  justify-content: space-between; 
  align-items: center; 
}

/* Navbar Brand */
.navbar-brand img {
  height: 40px;
  width: auto;
  transition: transform 0.3s ease;
}

.navbar-brand img:hover {
  transform: scale(1.1);
}

/* Title Styling */
.navbar-title {
  font-size: 1.5rem;
  color: rgba(255, 255, 255);
  font-weight: bold;
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

.navbar-title:hover {
  color: #00b9f1; 
  text-decoration: none;
}

/* Toggler */
.navbar-toggler {
  border: none;
}

.navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Navigation Links */
.navbar-nav .nav-link {
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  color: rgba(255, 255, 255);
  transition: color 0.3s ease, background-color 0.3s ease;
}

.navbar-nav .nav-link:hover {
  color: #00b9f1; 
  background-color: rgba(255, 255, 255, 0.1); 
  border-radius: 5px;
}

.navbar-nav .nav-link.active {
  color: #00b9f1; 
  font-weight: bold;
}

.nav-item {
  margin-right: 10px;
}

.collapse {
  justify-content: center;
}

.no-underline {
  text-decoration: none; 
}

/* Responsive hamburger menu background for 991px and below */
@media (max-width: 991px) {
  .navbar {
    position: fixed;
  }
  .navbar-collapse {
    background-color: black;
    padding: 1rem;
    border-radius: 5px;
    width: auto; 
    max-width: 200px;
    position: absolute; 
    top: 100%;
    right: 1rem; 
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 9999;
  }

  .navbar-nav {
    text-align: left; 
    margin-top: 1rem;
  }

  .navbar-nav .nav-item {
    margin-bottom: 10px;
  }

  .navbar-title {
    font-size: 1.25rem;
  }

  .navbar {
    top: 15%;
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 480px) {
  .navbar-collapse {
    width: auto !important;
    height: auto;
    max-width: 180px; 
    max-height: 90vh; 
    overflow-y: auto;
    top: 100%; 
    left: 2rem; 
    z-index: 9999;
    transition: all 0.3s ease;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,YAAY;AACd;;AAEA;EACE,yDAA6Q;AAC/Q;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,yBAAyB;EAC3B;AACF","sourcesContent":["/* General Navbar Styling */\n.navbar {\n  position: fixed; \n  top: 10%; \n  left: 50%; \n  width: 90%; \n  max-width: 1200px; \n  background-color: rgba(0, 0, 0, 0.25);\n  box-shadow: none;\n  padding: 1rem 2rem;\n  z-index: 1000; \n  border-radius: 10px; \n  transition: background-color 0.3s ease;\n  transform: translateX(-50%); \n  display: flex;\n  justify-content: space-between; \n  align-items: center; \n}\n\n/* Navbar Brand */\n.navbar-brand img {\n  height: 40px;\n  width: auto;\n  transition: transform 0.3s ease;\n}\n\n.navbar-brand img:hover {\n  transform: scale(1.1);\n}\n\n/* Title Styling */\n.navbar-title {\n  font-size: 1.5rem;\n  color: rgba(255, 255, 255);\n  font-weight: bold;\n  letter-spacing: 1px;\n  transition: color 0.3s ease;\n}\n\n.navbar-title:hover {\n  color: #00b9f1; \n  text-decoration: none;\n}\n\n/* Toggler */\n.navbar-toggler {\n  border: none;\n}\n\n.navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=UTF8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n\n/* Navigation Links */\n.navbar-nav .nav-link {\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  color: rgba(255, 255, 255);\n  transition: color 0.3s ease, background-color 0.3s ease;\n}\n\n.navbar-nav .nav-link:hover {\n  color: #00b9f1; \n  background-color: rgba(255, 255, 255, 0.1); \n  border-radius: 5px;\n}\n\n.navbar-nav .nav-link.active {\n  color: #00b9f1; \n  font-weight: bold;\n}\n\n.nav-item {\n  margin-right: 10px;\n}\n\n.collapse {\n  justify-content: center;\n}\n\n.no-underline {\n  text-decoration: none; \n}\n\n/* Responsive hamburger menu background for 991px and below */\n@media (max-width: 991px) {\n  .navbar {\n    position: fixed;\n  }\n  .navbar-collapse {\n    background-color: black;\n    padding: 1rem;\n    border-radius: 5px;\n    width: auto; \n    max-width: 200px;\n    position: absolute; \n    top: 100%;\n    right: 1rem; \n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 9999;\n  }\n\n  .navbar-nav {\n    text-align: left; \n    margin-top: 1rem;\n  }\n\n  .navbar-nav .nav-item {\n    margin-bottom: 10px;\n  }\n\n  .navbar-title {\n    font-size: 1.25rem;\n  }\n\n  .navbar {\n    top: 15%;\n    padding: 0.5rem 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar-collapse {\n    width: auto !important;\n    height: auto;\n    max-width: 180px; \n    max-height: 90vh; \n    overflow-y: auto;\n    top: 100%; \n    left: 2rem; \n    z-index: 9999;\n    transition: all 0.3s ease;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
